export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/48d0057cf54c678c61fc778c0aeda84f.svg";